import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CLIENT_V2, GET_CLIENT_V2_SUCCESS, GET_CLIENT_V2_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* getClientV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/client`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CLIENT_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: GET_CLIENT_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CLIENT_V2_ERROR, payload: error });
  }
}

export function* watchGetClientV2() {
  yield takeEvery(GET_CLIENT_V2, getClientV2);
}

function* getClientV2Saga() {
  yield all([fork(watchGetClientV2)]);
}

export default getClientV2Saga;
